import React from 'react';
import {NavLink} from 'react-router-dom';
import {StyleSheet, css} from 'aphrodite';
import {
  FaHome,
  FaSearch,
  FaReceipt,
  FaUser,
  FaShoppingCart,
} from 'react-icons/fa';

const tabs = [
  {name: 'Home', path: '/home', icon: FaHome},
  {name: 'Browse', path: '/browse', icon: FaSearch},
  {name: 'Orders', path: '/orders', icon: FaReceipt},
  {name: 'Cart', path: '/cart', icon: FaShoppingCart},
  {name: 'Profile', path: '/profile', icon: FaUser},
];

const BottomTabsWeb = () => {
  return (
    <nav className={css(styles.wrapper)}>
      {tabs.map(tab => {
        const Icon = tab.icon;

        return (
          <NavLink
            key={tab.name}
            to={tab.path}
            className={({isActive}) =>
              css(styles.tabItem, isActive && styles.activeTabItem)
            }>
            {({isActive}) => (
              <>
                <div className={css(styles.iconWrap, isActive && styles.activeIconWrap)}>
                  <Icon
                    size={18}
                    color={isActive ? '#FFFDF7' : '#8C8170'}
                  />
                </div>

                <span className={css(styles.label, isActive && styles.activeLabel)}>
                  {tab.name}
                </span>
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'fixed',
    left: '50%',
    bottom: '18px',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 32px)',
    maxWidth: '720px',
    height: '76px',
    backgroundColor: '#FFFDF7',
    border: '1px solid #E6D8BE',
    borderRadius: '28px',
    boxShadow: '0 18px 44px rgba(15, 61, 46, 0.16)',
    display: 'grid',
    gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
    alignItems: 'center',
    padding: '8px',
    boxSizing: 'border-box',
    zIndex: 900,
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',

    '@media (max-width: 520px)': {
      width: 'calc(100% - 20px)',
      bottom: '10px',
      height: '72px',
      borderRadius: '24px',
      padding: '7px',
    },
  },

  tabItem: {
    height: '100%',
    textDecoration: 'none',
    color: '#8C8170',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    borderRadius: '20px',
    transition: 'all 0.2s ease',

    ':hover': {
      backgroundColor: '#F4EBD8',
    },
  },

  activeTabItem: {
    backgroundColor: '#ffffff',
  },

  iconWrap: {
    width: '34px',
    height: '30px',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },

  activeIconWrap: {
    backgroundColor: '#0F3D2E',
  },

  label: {
    fontSize: '11px',
    fontWeight: '800',
    color: '#8C8170',

    '@media (max-width: 420px)': {
      fontSize: '10px',
    },
  },

  activeLabel: {
    color: '#0F3D2E',
  },
});

export default BottomTabsWeb;